module.exports = __webpack_public_path__ + "img/199.e310f50b.png";